import { redirect } from "react-router-dom";
import CheckToken from "../../services/CheckToken";

export default async function checkAuthenticated(
  setCheckLogin: (value: boolean) => void
) {
  try {
    const isAuthenticated = await CheckToken();
    if (isAuthenticated) {
      setCheckLogin(true);
      return null;
    }
    throw new Error();
  } catch {
    setCheckLogin(false);
    localStorage.removeItem("1");
    localStorage.removeItem("login");
    localStorage.removeItem("logs");
    return redirect("/login");
  }
}
